module.exports = __webpack_public_path__ + "assets/ProfissionalResidencia.0dd65dd9299f48de52462e4afda2b36b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/ProfissionalResidencia.png
 ** module id = 478
 ** module chunks = 0
 **/